import {GoogleDistanceService} from '@/service/google-distance.service';

const SEIRINGER_ORIGIN = 'Seiringer Umweltservice GmbH, Krügling 10, 3250 Wieselburg';

export class DistanceService {
  public static async calculateDistance(destination: string): Promise<number> {
    return GoogleDistanceService.getDistanceBetween(
      SEIRINGER_ORIGIN,
      destination
    );
  }
}
